import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const ChevronDownOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" transform="translate(6 8)" id="a" d="M9.875 1l-3.88 3.88L2.115 1a.996.996 0 1 0-1.41 1.41L5.295 7c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.39-1.42 0z" />
  </SvgIcon>
);
